module.exports = __webpack_public_path__ + "static/media/f5.c1d902f1.jpg";